<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{ t("operater") }}</a-breadcrumb-item>
      <a-breadcrumb-item class="black">
        <router-link :to="`${routerName.datastatistics}`">
          {{ t("datastatistics") }}
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("singlecardatastatistics")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <span style="font-weight: bold">vin：{{ vin }}</span>
      {{ t("timefiltering") }}：<a-range-picker
        v-model:value="timeValue"
        @change="changeTime"
        :allowClear="false"
      />
      <span style="margin: 0 20px">
        {{ t("tasktype") }}：
        <a-select
          v-model:value="optionValue"
          style="width: 10%"
          @change="getListData"
        >
          <a-select-option
            v-for="item in onLineStatusOptions"
            :key="item.value"
            v-model:value="item.value"
          >
            {{ item.label }}</a-select-option
          >
        </a-select></span
      >
      <a-button class="searchBtn addBtn" @click="downLoadList">{{
        t("statisticaldatadownload")
      }}</a-button>
    </div>
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight, x: 2650 }"
    >
      <template v-slot:bodyCell="{ column, index, record }">
        <template v-if="column.key === 'index'"> {{ index + 1 }}</template>
        <template v-if="column.key === 'total_time'">
          {{ yourFunction(record.total_time) }}</template
        >
        <template v-if="column.key === 'task_type'">
          {{ getTaskType(record.task_type, t) }}</template
        >
        <template v-if="column.key === 'is_timing'">
          {{ record.is_timing === "1" ? t("yes") : t("deny") }}</template
        >
        <template v-if="column.key === 'controls'">
          <a-button
            type="link"
            @click="
              goToCarDataDetail(record.id, record.task_type, record.category_id)
            "
            >{{ t("details") }}</a-button
          ></template
        >
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      show-size-changer
      show-quick-jumper
      :show-total="(totalNum) => `${t('intotal')} ${totalNum} ${t('article')}`"
      v-model:current="dataList.page"
      v-model:pageSize="dataList.size"
      :total="totalNum"
      size="small"
      @change="handlePaginationChange"
    />
  </div>
</template>
<script>
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { fromatDateYMD } from "@/utils/MyUtils";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getTaskType } from "../utils/DataConversionUtils";
import { useI18n } from "vue-i18n";

export default {
  name: "CarDataStatistics",
  setup() {
    const { t } = useI18n();

    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const dataSource = ref();
    const totalNum = ref(0);
    const optionValue = ref("0");
    const timeValue = ref();
    const setDefaultTime = () => {
      const end = dayjs();
      const start = dayjs().subtract(7, "day");
      timeValue.value = [start, end];
    };
    const onLineStatusOptions = ref([
      {
        value: "0",
        label: t("whole"),
      },
      {
        value: "1",
        label: t("combinedtasks"),
      },
      {
        value: "2",
        label: t("multifloortasks"),
      },
    ]);
    const dataList = ref({
      page: 1,
      size: 10,
    });
    const router = useRouter();
    const route = useRoute();
    const vin = route.query.vin;

    const getListData = () => {
      const param = {
        page: dataList.value.page,
        size: dataList.value.size,
        vin,
        start_time: fromatDateYMD(timeValue.value[0].toDate()),
        end_time: fromatDateYMD(timeValue.value[1].toDate()),
        task_type: optionValue.value,
      };
      Api.getCarTaskStatistics(param).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
          totalNum.value = res.totalNum * 1;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const handlePaginationChange = (page, pageSize) => {
      dataList.value.page = page;
      dataList.value.size = pageSize;
      getListData();
    };
    const changeTime = () => {
      getListData();
    };

    const downLoadList = () => {
      const param = new Object();
      param.vin = vin;
      param.start_time = fromatDateYMD(timeValue.value[0].toDate());
      param.end_time = fromatDateYMD(timeValue.value[1].toDate());
      param.vehicle_type = optionValue.value ? optionValue.value : "";
      Api.downloadTaskStatistics(param);
    };
    const goToCarDataDetail = (id, taskType, category_id) => {
      router.push({
        path: routerName.cardatastatisticsdetail,
        query: { id, taskType, category_id },
      });
    };
    const yourFunction = (time) => {
      if (Number(time) < 60) {
        return time + t("minute");
      }
      return Math.floor(time / 60) + t("hour") + (time % 60) + t("minute");
    };
    onMounted(() => {
      setDefaultTime();
      getListData();
    });

    return {
      dataSource,
      columns: [
        {
          title: t("serialnumber"),
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 130,
        },
        {
          title: t("taskname"),
          dataIndex: "task_name",
          key: "task_name",
          align: "center",
        },
        {
          title: t("tasktype"),
          dataIndex: "task_type",
          key: "task_type",
          align: "center",
        },
        {
          title: t("cleaningfrequency"),
          dataIndex: "cycle_index",
          key: "cycle_index",
          align: "center",
        },
        {
          title: t("cleaningmode"),
          dataIndex: "clean_mode",
          key: "clean_mode",
          align: "center",
        },
        {
          title: t("taskstarttime"),
          dataIndex: "start_time",
          key: "start_time",
          align: "center",
        },
        {
          title: t("taskendtime"),
          dataIndex: "end_time",
          key: "end_time",
          align: "center",
        },
        {
          title: t("cleaningtime"),
          dataIndex: "total_time",
          key: "total_time",
          align: "center",
        },
        {
          title: t("waterconsumption"),
          dataIndex: "use_water",
          key: "use_water",
          align: "center",
        },
        {
          title: t("electricityconsumption") + "(kW·h)",
          dataIndex: "power_consumption",
          key: "power_consumption",
          align: "center",
        },
        {
          title: t("plannedcleaningaream2"),
          dataIndex: "plan_clean_area",
          key: "plan_clean_area",
          align: "center",
        },
        {
          title: t("actualcleaningaream2"),
          dataIndex: "actual_clean_area",
          key: "actual_clean_area",
          align: "center",
        },
        {
          title: t("uncleanedaream2"),
          dataIndex: "uncleaned_area",
          key: "uncleaned_area",
          align: "center",
        },
        {
          title: t("cleaningefficiencyh") + "(㎡/h)",
          dataIndex: "clean_rate",
          key: "clean_rate",
          align: "center",
        },
        {
          title: t("operator"),
          dataIndex: "cleaner",
          key: "cleaner",
          align: "center",
        },
        {
          title: t("scheduledtasks"),
          dataIndex: "is_timing",
          key: "is_timing",
          align: "center",
        },
        {
          title: t("operate"),
          dataIndex: "controls",
          key: "controls",
          align: "center",
        },
      ],
      dataList,
      totalNum,
      handlePaginationChange,
      getListData,
      optionValue,
      onLineStatusOptions,
      timeValue,
      changeTime,
      downLoadList,
      goToCarDataDetail,
      getTaskType,
      yourFunction,
      vin,
      maxHeight,
      routerName,
      t,
    };
  },
};
</script>
<style scoped></style>
